
// frontend/src/components/Sports/SportsConfig.js

export const LEAGUE_CONFIG = {
    // SOCCER
    'premier-league': {
        id: 'eng.1',
        sport: 'soccer',
        name: 'Premier League',
        newsCategory: 'soccer',
        color: 'from-purple-600 to-blue-600'
    },
    'la-liga': {
        id: 'esp.1',
        sport: 'soccer',
        name: 'La Liga',
        newsCategory: 'soccer',
        color: 'from-orange-500 to-red-600'
    },
    'bundesliga': {
        id: 'ger.1',
        sport: 'soccer',
        name: 'Bundesliga',
        newsCategory: 'soccer',
        color: 'from-red-600 to-yellow-500'
    },
    'serie-a': {
        id: 'ita.1',
        sport: 'soccer',
        name: 'Serie A',
        newsCategory: 'soccer',
        color: 'from-blue-400 to-cyan-500'
    },
    'champions-league': {
        id: 'uefa.champions',
        sport: 'soccer',
        name: 'Champions League',
        newsCategory: 'soccer',
        color: 'from-blue-800 to-indigo-900'
    },
    // US SPORTS
    'nba': {
        id: 'nba',
        sport: 'basketball',
        name: 'NBA',
        newsCategory: 'nba',
        color: 'from-orange-600 to-red-700'
    },
    'nfl': {
        id: 'nfl',
        sport: 'football',
        name: 'NFL',
        newsCategory: 'nfl',
        color: 'from-blue-700 to-red-600'
    },
    'f1': {
        id: 'f1', // Check API support
        sport: 'racing',
        name: 'Formula 1',
        newsCategory: 'f1',
        color: 'from-red-600 to-black'
    }
};

export const getLeagueConfig = (slug) => LEAGUE_CONFIG[slug] || null;
